'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * WH AccordionContent Component.
 * @param {Object} props The new component properties.
 * @returns {React$Element<any>}  HTML markup for the component
 */
var AccordionContent = function (_Component) {
    (0, _inherits3.default)(AccordionContent, _Component);

    function AccordionContent(props) {
        (0, _classCallCheck3.default)(this, AccordionContent);

        var _this = (0, _possibleConstructorReturn3.default)(this, (AccordionContent.__proto__ || (0, _getPrototypeOf2.default)(AccordionContent)).call(this, props));

        _this.state = {
            height: 0
        };
        return _this;
    }

    (0, _createClass3.default)(AccordionContent, [{
        key: 'calcHeight',
        value: function calcHeight(node) {
            if (node && !this.state.height) {
                this.setState({ height: node.offsetHeight });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                isOpen = _props.isOpen,
                children = _props.children,
                _props$id = _props.id,
                id = _props$id === undefined ? '' : _props$id;
            var height = this.state.height;

            var style = height && isOpen ? { maxHeight: height } : null;

            var classNames = (0, _classnames2.default)({
                'sb-accordion__content': true,
                'sb-accordion__content--height': !!height
            });

            return _react2.default.createElement(
                'div',
                { ref: function ref(node) {
                        return _this2.calcHeight(node);
                    }, className: classNames, style: style, id: id },
                children
            );
        }
    }]);
    return AccordionContent;
}(_react.Component);

exports.default = AccordionContent;
//# sourceMappingURL=AccordionContent.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/ui-components/dist/main/components/accordion/AccordionContent.js
// module id = 542
// module chunks = 0